import Vue from "vue";
import Router from "vue-router";
import Scan from "components/scan/scan";
import nbBank from "components/nbBank";
import jtBank from "components/jtBank";
import InsideScan from "components/insideScan/insideScan";
import findTargetApp from "components/findTarget/findTargetApp";
import findTargetAppError from "components/findTarget/findTargetAppError";
import CulturalPalace from "components/culturalPalace/culturalPalace";

import memberOrder from "components/order/memberOrder";
import UnlicensedEntry from "components/unlicensed/unlicensedEntry";
import SupplementaryUnlicensed from "components/unlicensed/SupplementaryUnlicensed";
import SupplementaryPayment from "components/order/SupplementaryPayment";
import Unlicensed from "components/unlicensed/unlicensed";
import Main from "components/main";
import Polling from "components/polling";
import error from "components/404.vue";
import Test from "components/test";
import PayResult from "components/pay-result/pay-result";
import result from "components/pay-result/result";
import payerror from "components/pay-result/error";
import paySuccess from "components/pay-result/pay-success";
import InsideOrder from "components/order/insideOrder";

import orderInfo from "components/order/orderInfo";
import Order from "components/order/order";

import merChantParkingFee from "components/weChat/merChantParkingFee/index";
import merChantParkingFeexcx from "components/weChat/merChantParkingFee/xcxindex";
import parkingFeeList from "components/weChat/parkingFeeList";
import rationFee from "components/weChat/rationFee";
import PaymentCertificate from "components/weChat/PaymentCertificate";
import directBind from "components/weChat/directBind";
import rationRecord from "components/weChat/rationRecord";
import personalParkingFee from "components/weChat/personalParkingFee/index";
import personalParkingFeexcx from "components/weChat/personalParkingFee/xcxindex";
import personalBind from "components/weChat/personalBind";
import personalCenter from "components/weChat/personalCenter";
import receiptOptions from "components/weChat/receiptOptions";
import userParkingFeeList from "components/weChat/userParkingFeeList";
// import couponOrder from "components/weChat/couponOrder";
import receiptForWrite from "components/weChat/receiptForWrite";
import receiptResult from "components/weChat/receiptResult";
import receiptHistory from "components/weChat/receiptHistory";
import ticketDetails from "components/weChat/ticketDetails";

import bindPlate from "components/weChat/bindPlate/index";
import bindPlatexcx from "components/weChat/bindPlate/xcxindex";

import plateInfo from "components/weChat/plateInfo/index";
import plateInfoxcx from "components/weChat/plateInfo/xcxindex";

import register from "components/weChat/register/index";
import xcxRegister from "components/weChat/register/xcxRegister";
import scanResult from "components/weChat/scanResult";
import platePay from "components/weChat/platePay";
import auth from "components/weChat/auth";
import toScan from "components/weChat/toScan";
import toPayParkingFee from "components/weChat/parkingFee/toPayParkingFee";
import merChantToPayParkingFee from "components/weChat/parkingFee/merChantToPayParkingFee";
import parkingFeeOptions from "components/weChat/parkingFee/options";

import parkingLotOptions from "components/weChat/parkingLot/options";
import detailed from "components/weChat/parkingLot/detailed";
import ParkingSpace from "components/weChat/parkingLot/ParkingSpace";
import ParkingDetails from "components/weChat/parkingLot/ParkingDetails";

import roadside from "components/weChat/parkingLot/roadside";

import Login from "components/weChat/parkingLot/login";

import parkingFeeRecord from "components/weChat/parkingFee/record";
import userNoFollowToGetCoupon from "components/weChat/userNoFollowToGetCoupon";

import paymentAdvance from "components/weChat/paymentAdvance";
import paymentAdvanceerror from "components/weChat/paymentAdvanceerror";

import testIndex from "components/testIndex";
import clear from "components/clear";
import payMoney from "components/weChat/payMoney";
import salePayMoney from "components/weChat/salePayMoney";
import Fixedvehicle from "components/weChat/Fixedvehicle";
import scanPayMoney from "components/weChat/scanPayMoney";
import Payment from "components/weChat/Payment";
import PaymentAmount from "components/weChat/PaymentAmount";

import config from "../api/base";
import { redirectToWeChatAuth } from "@/utils/redirect";
import { LocationManager } from "@/utils/LocationManagerUrl";
import axios from "axios";

Vue.use(Router);

const router = new Router({
    mode: "history",
    base: "/",
    routes: [
        {
            name: "findTargetApp", //苏州小程序第三方中转页
            path: "/findTargetApp",
            component: findTargetApp
        },
        {
            name: "findTargetAppError", //苏州小程序第三方中转页
            path: "/findTargetAppError",
            component: findTargetAppError
        },
        {
            name: "Scan",
            path: "/scan",
            component: Scan
        },
        {
            name: "nbBank",
            path: "/nbBank",
            component: nbBank
        },
        {
            name: "jtBank",
            path: "/jtBank",
            component: jtBank
        },
        {
            name: "InsideScan",
            path: "/insideScan",
            component: InsideScan
        },

        {
            name: "CulturalPalace",
            path: "/culturalPalace",
            component: CulturalPalace
        },
        {
            name: "Order",
            path: "/order",
            component: Order
        },
        {
            name: "memberOrder",
            path: "/order/memberOrder/:parkinglotId",
            component: memberOrder
        },
        {
            name: "Main",
            path: "/main",
            component: Main
        },
        {
            name: "UnlicensedEntry",
            path: "/unlicensedEntry",
            component: UnlicensedEntry
        },
        {
            name: "SupplementaryUnlicensed",
            path: "/SupplementaryUnlicensed",
            component: SupplementaryUnlicensed
        },
        {
            name: "SupplementaryPayment",
            path: "/SupplementaryPayment",
            component: SupplementaryPayment
        },
        {
            name: "Unlicensed",
            path: "/unlicensed/:parkinglotId/:doorId",
            component: Unlicensed
        },
        {
            name: "Polling",
            path: "/polling",
            component: Polling
        },
        {
            name: "error",
            path: "/error",
            component: error
        },
        {
            name: "Test",
            path: "/test",
            component: Test
        },
        {
            name: "testIndex",
            path: "/testIndex",
            component: testIndex
        },
        {
            name: "clear",
            path: "/clear",
            component: clear
        },
        {
            name: "PayResult",
            path: "/payResult",
            component: PayResult
        },
        {
            name: "Result",
            path: "/result",

            component: result
        },
        {
            name: "payerror",
            path: "/payerror",

            component: payerror
        },
        {
            name: "paySuccess",
            path: "/paySuccess",
            component: paySuccess
        },
        {
            name: "InsideOrder",
            path: "/insideOrder",
            beforeEnter: (to, from, next) => {
                console.log(to, "546456456");
                console.log(from, "from");
                if (from.name == "Result") {
                    next("/payerror");
                    // next();
                } else {
                    next();
                }
            },
            component: InsideOrder
        },
        {
            name: "ticketDetails",
            path: "/ticketDetails",
            component: ticketDetails
        },
        {
            name: "orderInfo",
            path: "/orderInfo",
            component: orderInfo
        },
        {
            name: "merChantParkingFee",
            path: "/weChat/merChantParkingFee",
            meta: {
                title: "商户停车券"
            },
            component: merChantParkingFee
        },
        {
            name: "merChantParkingFeexcx",
            path: "/weChat/merChantParkingFeexcx",
            meta: {
                title: "商户停车券"
            },
            component: merChantParkingFeexcx
        },
        {
            name: "parkingFeeList",
            path: "/weChat/parkingFeeList",
            meta: {
                title: "购买停车券"
            },
            component: parkingFeeList
        },
        {
            name: "rationFee",
            path: "/weChat/rationFee",
            meta: {
                title: "发放停车券"
            },
            component: rationFee
        },
        {
            name: "PaymentCertificate",
            path: "/weChat/PaymentCertificate",
            meta: {
                title: "预付券发放停车券"
            },
            component: PaymentCertificate
        },
        {
            name: "directBind",
            path: "/weChat/directBind/:parkinglotId",
            meta: {
                title: "直接绑定"
            },
            component: directBind
        },
        {
            name: "rationRecord",
            path: "/weChat/rationRecord",
            meta: {
                title: "发放记录"
            },
            component: rationRecord
        },
        {
            name: "personalParkingFee",
            path: "/weChat/personalParkingFee",
            meta: {
                title: "我的停车券"
            },
            component: personalParkingFee
        },
        {
            name: "personalParkingFeexcx",
            path: "/weChat/personalParkingFeexcx",
            meta: {
                title: "我的停车券"
            },
            component: personalParkingFeexcx
        },
        {
            name: "personalBind",
            path: "/weChat/personalBind",
            meta: {
                title: "绑定停车券"
            },
            component: personalBind
        },
        {
            name: "personalCenter",
            path: "/weChat/personalCenter",
            meta: {
                title: "个人中心"
            },
            component: personalCenter
        },
        {
            name: "receiptOptions",
            path: "/weChat/receiptOptions",
            meta: {
                title: "开具发票"
            },
            component: receiptOptions
        },
        {
            name: "receiptForWrite",
            path: "/weChat/receiptForWrite/:receiptType",
            meta: {
                title: "开具电子发票"
            },
            component: receiptForWrite
        },
        {
            name: "receiptResult",
            path: "/weChat/receiptResult",
            meta: {
                title: "开具发票"
            },
            component: receiptResult
        },
        {
            name: "receiptHistory",
            path: "/weChat/receiptHistory",
            meta: {
                title: "开票历史"
            },
            component: receiptHistory
        },
        {
            name: "userParkingFeeList",
            path: "/weChat/userParkingFeeList",
            meta: {
                title: "停车费列表"
            },
            component: userParkingFeeList
        },
        // {
        //     name: "couponOrder",
        //     path: "/weChat/couponOrder",
        //     meta: {
        //         title: "优惠券订单"
        //     },
        //     component: couponOrder
        // },

        {
            name: "bindPlate",
            path: "/weChat/bindPlate",
            meta: {
                title: "绑定车辆"
            },
            component: bindPlate
        },
        {
            name: "bindPlatexcx",
            path: "/weChat/bindPlatexcx",
            meta: {
                title: "绑定车辆"
            },
            component: bindPlatexcx
        },
        {
            name: "plateInfo",
            path: "/weChat/plateInfo",
            meta: {
                title: "车辆管理"
            },
            component: plateInfo
        },
        {
            name: "plateInfoxcx",
            path: "/weChat/plateInfoxcx",
            meta: {
                title: "车辆管理"
            },
            component: plateInfoxcx
        },
        {
            name: "register",
            path: "/weChat/register",
            meta: {
                title: "注册"
            },
            component: register
        },
        {
            name: "xcxRegister",
            path: "/weChat/xcxRegister",
            meta: {
                title: "注册"
            },
            component: xcxRegister
        },
        {
            name: "scanResult",
            path: "/weChat/scanResult",
            meta: {
                title: "结果页"
            },
            component: scanResult
        },
        {
            name: "platePay",
            path: "/weChat/platePay",
            meta: {
                title: "缴费"
            },
            component: platePay
        },
        {
            name: "auth",
            path: "/weChat/auth",
            meta: {
                title: "登陆授权"
            },
            component: auth
        },
        {
            name: "toScan",
            path: "/weChat/toScan",
            meta: {
                title: "扫一扫"
            },
            component: toScan
        },
        {
            name: "parkingFee",
            path: "/weChat/parkingFee",
            meta: {
                title: "车位费"
            },
            component: parkingFeeOptions
        },

        {
            name: "parkingLot",
            path: "/weChat/parkingLot/options",
            meta: {
                title: "车位"
            },
            component: parkingLotOptions
        },
        {
            name: "detailed",
            path: "/weChat/parkingLot/detailed",
            meta: {
                title: "车位信息"
            },
            component: detailed
        },
        {
            name: "ParkingSpace",
            path: "/weChat/parkingLot/ParkingSpace",
            meta: {
                title: "车位信息详情"
            },
            component: ParkingSpace
        },
        {
            name: "ParkingDetails",
            path: "/weChat/parkingLot/ParkingDetails",
            meta: {
                title: "详情"
            },
            component: ParkingDetails
        },
        {
            name: "roadside",
            path: "/weChat/parkingLot/roadside",
            meta: {
                title: "订单详情"
            },
            component: roadside
        },
        {
            name: "Login",
            path: "/weChat/parkingLot/login",
            meta: {
                title: "登录"
            },
            component: Login
        },

        {
            name: "toPayParkingFee",
            path: "/weChat/parkingFee/toPayParkingFee",
            meta: {
                title: "个缴车位费"
            },
            component: toPayParkingFee
        },
        {
            name: "merChantToPayParkingFee",
            path: "/weChat/parkingFee/merChantToPayParkingFee",
            meta: {
                title: "商缴车位费"
            },
            component: merChantToPayParkingFee
        },
        {
            name: "parkingFeeRecord",
            path: "/weChat/parkingFee/record",
            meta: {
                title: "车位费缴费历史"
            },
            component: parkingFeeRecord
        },
        {
            name: "userNoFollowToGetCoupon",
            path: "/weChat/userNoFollowToGetCoupon",
            meta: {
                title: "车牌号领券"
            },
            component: userNoFollowToGetCoupon
        },
        {
            name: "paymentAdvance",
            path: "/weChat/paymentAdvance",
            meta: {
                title: "预付券领券"
            },
            component: paymentAdvance
        },
        {
            name: "paymentAdvanceerror",
            path: "/weChat/paymentAdvanceerror",
            meta: {
                title: "错误页面"
            },
            component: paymentAdvanceerror
        },
        {
            path: "/weChat/payMoney",
            component: payMoney,
            name: "payMoney",
            meta: { title: "支付" }
        },
        {
            path: "/weChat/salePayMoney",
            component: salePayMoney,
            name: "salePayMoney",
            meta: { title: "预付券支付" }
        },
        {
            path: "/weChat/Fixedvehicle",
            component: Fixedvehicle,
            name: "Fixedvehicle",
            meta: { title: "新增月租车" }
        },
        {
            path: "/weChat/scanPayMoney",
            component: scanPayMoney,
            name: "scanPayMoney",
            meta: { title: "支付" }
        },
        {
            path: "/weChat/Payment",
            component: Payment,
            name: "Payment",
            meta: { title: "商户代付" }
        },
        {
            path: "/weChat/PaymentAmount",
            component: PaymentAmount,
            name: "PaymentAmount",
            meta: { title: "商户代付" }
        }
    ]
});
// function isLocalEnvironment() {
//     return window.location.hostname === 'localhost' ||
//            window.location.hostname === '127.0.0.1' ||
//            window.location.hostname.includes('localhost:');
//   }
const environment = process.env.VUE_APP_ENV || "development";
function authAddress(browser) {
    redirectToWeChatAuth("/weChat/auth");
}
const WHITE_LIST = [
    "userNoFollowToGetCoupon",
    "unlicensedEntry",
    "SupplementaryUnlicensed",
    "unlicensed",
    "roadside",
    "detailed",
    "parkingLotOptions",
    "ParkingSpace",
    "options",
    "ParkingDetails",
    "login",
    "salePayMoney",
    "Fixedvehicle",
    "paymentAdvance" // 新增paymentAdvance到白名单
];
function tokenAuth(to, next) {
    // window.localStorage.setItem('userOpenId',"oIeS5096YkRhN1UYtIT4MxE8k0p8")
    // window.localStorage.setItem('userId',"16")

    let userOpenid = localStorage.getItem("userOpenId");
    let userBuyId = localStorage.getItem("userBuyId");
    let userId = localStorage.getItem("userId");

    if (to.fullPath != "/weChat/auth") {
        localStorage.setItem("beforeUrl", to.fullPath);
    }

    let browser = Vue.prototype.checkBrowser;
    console.log(browser, "browser");
    console.log(userBuyId, "userBuyId");
    if (browser.id === "12") {
        // 支付宝
        if (!userBuyId) {
            // next()
            authAddress(browser);
        } else {
            next();
        }
    } else if (browser.id === "13") {
        //if (browser.id === "13")
        // 微信//
      

        if (!userOpenid) {
            // next()
            // 如果没有openId,则让它授权。保存当前路由地址，授权后还会跳到此地址。授权请求,并跳转auth路由页面
   
            authAddress(browser);
        } else if (!userId &&!WHITE_LIST.some(path => to.fullPath.includes(path))) {
  
            LocationManager("/weChat/register");
        } else {
            console.log("放行");
            next();
        }
    } else {
        alert("请使用微信/支付宝打开");
    }
}

router.beforeEach((to, from, next) => {
    let path =
        to.path.indexOf("weChat") >= 0 ||
        to.name === "UnlicensedEntry" ||
        to.name === "SupplementaryUnlicensed" ||
        to.name === "Unlicensed";
    console.log(path, "路由path");
    // let path =  (to.name === "UnlicensedEntry") || (to.name === "Unlicensed");
    // 公众号及无牌车进出
    if (path) {
        // 需要授权的页面地址
        if (to.name !== "auth" && to.name !== "toScan" && to.name !== "register"&& to.name !== "paymentAdvance") {
            console.log("需要授权的页面地址");
            
            tokenAuth(to, next);
        } else {
            next();
        }
    } else {
        next();
    }
});
export default router;
